/**
 * Handles the browser cookies.
 *
 * Usage example:
 * ==============
 * let cookies = new Cookies();									// Creates a new Cookies object
 * console.log(cookies.all);									// Logs all cookies as an object
 * console.log(cookies.set('test_name', 'test_value', 0.5));	// Sets and logs a 'test_name=test_value;' cookie with an expiration period of 30 minutes
 * console.log(cookies.get('test_name'));						// Gets and logs the value of a cookie with the name 'test_name'
 * console.log(cookies.remove('test_name'));					// Removes and logs a cookie with the name 'test_name'
 */
export default class Cookies {

	/**
	 * Constructor method.
	 */
	constructor() {
		this.all = this.getAll();
	}

	/**
	 * Update method.
	 */
	update() {
		this.all = this.getAll();
	}

	/**
	 * Gets a cookie value by its name.
	 * @param  {string} name Cookie name
	 * @return {string|object|bool}
	 */
	get(name) {
		// Return all if no cookie name is provided
		if (typeof name === 'undefined') {
			return this.getAll();
		}

		// Split cookies into an array
		let decodedCookies = decodeURIComponent(document.cookie);
		let cookiesArray = decodedCookies.split(';');

		// Find and return cookie
		for (let cookie of cookiesArray) {
			while (cookie.charAt(0) == ' ') {
				cookie = cookie.substring(1);
			}
			if (cookie.indexOf(`${name}=`) == 0) {
				let value = cookie.substring(`${name}=`.length, cookie.length);
				return value;
			}
		}

		// Not found
		return false;
	}

	/**
	 * Gets all cookies as an object.
	 * @return {object}
	 */
	getAll() {
		// Set cookies object
		let cookies = {}

		// Split cookies into an array
		let decodedCookies = decodeURIComponent(document.cookie);
		let cookiesArray = decodedCookies.split(';');

		// Loop and push to cookies
		for (let cookie of cookiesArray) {
			let part = cookie.split('=');
			if (part.length > 1) {
				cookies[part[0]] = part[1];
			}
		}

		// Results
		return cookies;
	}

	/**
	 * Sets a cookie by its name, value and duration.
	 * @param  {string} name  Cookie name
	 * @param  {string} value Cookie value
	 * @param  {number} hours Duration period in hours
	 * @return {bool}
	 */
	set(name, value, hours) {
		// Check paramaters
		if (typeof name !== 'string' || (typeof value !== 'string' && typeof value !== 'number') || typeof hours !== 'number') {
			return false;
		}

		// Set cookie
		var d = new Date();
		d.setTime(d.getTime() + (3600000 * hours));
		var expires = 'expires=' + d.toUTCString();
		document.cookie = name + '=' + value + '; ' + expires + '; path=/';

		// Successful
		return true;
	}

	/**
	 * Removes a cookie by its name.
	 * @return {bool}
	 */
	remove(name) {
		// Check name
		if (typeof name === 'undefined') {
			return false;
		}

		// Check if cookie exists
		if (this.get(name) === false) {
			return false;
		}

		// Remove the cookie
		document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';

		// Successful
		return true;
	}

}
